export const CONFERENCE_SOURCE = {
  telegram: 1,
  jazz: 2,
};

export const CONFERENCE_SOURCE_LABEL = {
  [CONFERENCE_SOURCE.telegram]: 'Telegram трансляция',
  [CONFERENCE_SOURCE.jazz]: 'Sber Jazz трансляция',
};

export const CONFERENCE_TELEGRAM_TYPE = {
  course: 1,
  group: 2,
  user: 3,
  enrollment: 4,
};

export default {
  CONFERENCE_SOURCE,
  CONFERENCE_SOURCE_LABEL,
  CONFERENCE_TELEGRAM_TYPE,
};
